import { lazy, Suspense } from "react";
import Page from "@jumbo/shared/Page";
import groupedVeneerMiddleware from "./middleware/auth/groupedVeneerValidRoute";

// ✅ Lazy import
const GroupedVeneerList = lazy(() => import("app/pages/Inventory/GroupedVeneer"));

export const groupedVeneerRoutes = [
  {
    middleware: [
      {
        element: groupedVeneerMiddleware,
        fallbackPath: "/dashboard",
      },
    ],
    routes: [
      {
        path: "/dashboard/inventory/groupedveneer",
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Page component={GroupedVeneerList} layout={"vertical-default"} />
          </Suspense>
        ),
      },
    ],
  },
];
